import React, {useEffect, useRef, useState} from 'react';
import PhoneInput from "../PhoneInput";
import {useAlert} from "react-alert";
import makeRequest from "../../api/makeRequest";
import CodeInput from "../CodeInput";
import * as auth from "../../modules/Auth/_redux/authRedux";
import {connect} from "react-redux";
import { requestPhoneCode, verifyPhone } from '../../modules/Auth/_redux/authCrud';
import { useLocation } from 'react-router-dom';
const PhoneVerify = ({match,redirect = window.location.href,requestUser,login}) => {
	const alert = useAlert()

	const { params } = match
	const paramsPhone = params?.phone || '09'
	const defaultStep = params.phone ? 2 : 1

	const location = useLocation();
	const redirectIt = location?.pathname?.indexOf('verifyPhone') === -1

	const MAX_STEP = 2
	const [step,setStep] = useState(defaultStep)
	const [phone,setPhone] = useState(paramsPhone)
	const [code,setCode] = useState('')
	const [loading,setLoading] = useState(false)
	const [disableRequestCode,setDisableRequestCode] = useState(false)
	const [firstTimeReq,setFirstTimeReq] = useState(true)
	const [timer,setTimer] = useState(0)
	useEffect(()=>{
		if(timer <= 0) return ;
		setTimeout(()=>{
			setTimer(p=>{
				if(p === 1) setDisableRequestCode(false)
				return p-1
			})
		},1000)
	},[timer])

	const handlePhoneChange = (ph) => {
		setPhone(ph)
		if(ph.length === 11) {
			changeStep(1,ph)
		}
	}
	const handleCodeChange = (c) => {
		setCode(c)
		if(c.length === 6) {
			changeStep(2,c)
		}
	}

	const FirstTimeRef = useRef(true)

	const doRedirect = ()=> {
		setTimeout(()=>{
			window.location.href = redirect
		},500)
	}

	const refillUser = async () => {
		try{
			await requestUser();
		}catch{}
	}

	const sendCode = async (data)=> {
		try {
			const result = await requestPhoneCode(data ? data : phone);
			if(result && result.data) {
				const {data} = result || {}
				const {success} = data
				if (success) {
					if(FirstTimeRef.current){
						FirstTimeRef.current = false
						setDisableRequestCode(true)
						setTimer(90)
					}else{
						setFirstTimeReq(false)
					}
					
					return [true, '']
				} else {
					const {error,code} = data
					if(code === 1027) {
						await refillUser()
						doRedirect()
					}
					return [false, error]
				}
			}else{
				return [false,'error']
			}
		}catch (e) {
			return [false,(e?.message || 'error')]
		}
	}

	const checkCode = async (data)=> {
		try {
			const result = await verifyPhone(phone,data ? data : code);
			if(result && result.data) {
				const {data} = result
				const {success} = data
				if (success) {
					// await refillUser()
					return [data.token, '']
				} else {
					const {error,code} = data
					if(code === 1030) setStep(1)
					return [false, error]
				}
			}else{
				return [false,'error']
			}
		}catch (e) {
			return [false,(e?.message || 'error')]
		}
	}

	const sendAgainCode = async () => {
		setLoading(true)
		const [scStatus,scError] = await sendCode()
		setLoading(false)
		if(scStatus){
			alert.success('کد ارسال شد.')
		}else{
			alert.error(scError)
			return
		}
	}

	const changeStep = async (currentStep,data)=>{
		setLoading(true)
		//validate each step and do actions
		switch (currentStep){
			case 1:
				const phoneRgx = new RegExp(`^09[0-9]{9}$`)
				const validPhone = phoneRgx.test(data ? data : phone)
				if(!validPhone) {
					alert.error('شماره تلفن نامعتبر')
					return
				}
				const [scStatus,scError] = await sendCode(data)
				if(scStatus){
					alert.success('کد ارسال شد.')
				}else{
					alert.error(scError)
					setLoading(false)
					return
				}
				break;
			case 2:
				if(!data){
					const validCode = code.length === 6
					if(!validCode) {
						alert.error('کد را وارد کنید.')
						return
					}
				}
				const [ccStatus,ccError] = await checkCode(data)
				if(ccStatus){
					alert.success('کد تایید شد .')
					if(redirectIt) localStorage.setItem("redirect", "/reset/password");
					return login({authToken: ccStatus});
				}else{
					alert.error(ccError)
					setLoading(false)
					return
				}
				break;
		}
		const nextStep = (currentStep + 1)
		if(nextStep > MAX_STEP) {
			doRedirect()
		}else{
			setStep(nextStep)
		}
		setLoading(false)
	}
	if(step === 3) return ''
	return (
		<div className="sf-phone-verify">
			{step === 1 && (
				<>
					<p>برای ادامه لازم است شماره <strong>تلفن همراه</strong> خود را وارد کنید.</p>
					<PhoneInput phone={phone} onChange={handlePhoneChange}/>
				</>
			)}
			{step === 2 && (
				<>
					<p>کد ارسال شده را وارد کنید .</p>
					<CodeInput code={code} onChange={handleCodeChange}/>
				</>
			)}
			<div className="d-flex flex-wrap justify-content-between align-items-center w-100">
				{step === 2 && (
					<>
						{!params.phone ? <button
							onClick={()=>changeStep(0)}
							type="submit"
							className={`btn btn-link-dark mx-4 text-dark-65`}
						>
							<span>تغییر شماره</span>
						</button> : '' }
						<button
							onClick={()=>sendAgainCode()}
							type="submit"
							disabled={!firstTimeReq && disableRequestCode}
							className={`btn btn-link-dark mx-4 text-dark-65`}
						>
							<span>ارسال مجدد</span>
						</button>
					</>
				)}
				<button
					onClick={()=>changeStep(step)}
					type="submit"
					className={`btn btn-hover-info btn-light-twitter font-weight-bold px-9 py-4 ml-auto`}
				>
					<span>تایید</span>
					{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
				</button>
			</div>
			{
				(!firstTimeReq && timer) &&
				<div className="d-flex justify-content-start mt-5 timeline-badge w-100 text-black-50">لطفا {timer} ثانیه دیگر تلاش کنید .</div>
			}
		</div>
	)
}

export default (connect(null, auth.actions)(PhoneVerify));